<template>
  <v-container>
    <div class="ml-0 mr-0">
      <v-img src="@/assets/Create_Store/Banner-3.png" class="rounded-xl"  ></v-img>
    </div>
    <v-card  width="100%" height="100%" elevation="0" class="mb-4 mt-3" style="padding-Top:1%">
      <v-card elevation="0" width="100%" height="100%">
        <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">ข้อมูลร้านค้า</v-card-title>
        <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-if="MobileSize">
          <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลร้านค้า
        </v-card-title>
      </v-card>
      <v-container>
        <v-row >
          <v-col cols="12" sm="12" md="6" :class="MobileSize ? 'mb-3' : ''">
            <v-card >
              <v-row >
                <v-col cols="2" >
                  <!-- shop_image -->
                  <v-avatar class="ml-4 rounded-circle "  tile :width="IpadProSize ? '100px' : IpadSize ? '70px' :'100px'" :height="IpadProSize ? '100px' : IpadSize ? '70px' : '100px'">
                    <v-img v-if="shop_image === null  || shop_image === 0 || shop_image === ''" src="@/assets/ImageINET-Marketplace/Shop/Store2.png" contain></v-img>
                    <v-img class="rounded-circle " v-else :src="shop_image.media_path" ></v-img>
                  </v-avatar>
                  <v-card width="32px" style="margin-Top:-15px" :style="IpadProSize ? 'margin-left:47px' : IpadSize ? 'margin-left:50px': 'margin-left:49px' " @click="dialogOpenScan()">
                    <v-icon size="25" style="margin:3px" color="#27AB9C">mdi-qrcode-scan</v-icon>
                  </v-card>
                </v-col>

                <v-col cols="9">
                  <v-row>
                    <v-col :cols="IpadProSize ? 10 : MobileSize ? 10 : 11">
                      <h2 :class="IpadProSize ? 'ml-15' : MobileSize ? 'ml-16 mobile14' : 'ml-12'">{{ shop_name}}</h2>
                    </v-col>
                    <v-col :cols="MobileSize ? 2 : 1" align="end">
                      <v-btn icon><v-icon size="24" color="#27AB9C" @click="editshop()">mdi-pencil</v-icon></v-btn>
                      <!-- <v-btn icon dense>
                        <v-avatar size="27" >
                          <v-img contain :src="require('@/assets/icons/edit-2.png')" @click="editshop()" ></v-img>
                        </v-avatar>
                      </v-btn> -->
                    </v-col>
                  </v-row>
                  <span :class="IpadProSize ? 'ml-14 mb-20' : MobileSize ? 'ml-15' : 'ml-10 mb-20'"><v-icon color="#BEBEBE">mdi-map-marker</v-icon><font color="#BEBEBE">{{shop_province}}</font></span><br/>
                  <span :class="IpadProSize ? 'ml-14 mt-2' : MobileSize ? 'ml-16' : 'ml-12 mt-2'"><font color="#0061A8">{{ shop_countAll }}</font> รายการสินค้า</span>
                </v-col>

                <v-col cols="11" class="ml-4">
                  <v-container style="min-height: 295px; height: auto;" class="pb-2">
                    <h3><B>ข้อมูลติดต่อ</B></h3>
                    <span  style="font-weight: 400; color: #333333;" :style="MobileSize ? 'font-size: 12px;':'font-size: 14px;'">
                      บ้านเลขที่: {{this.shopAddress.house_no === null ? '-' : this.shopAddress.house_no}}   ตำบล/เขต: {{this.shopAddress.sub_district === null ? '-' : this.shopAddress.sub_district}}
                      อำเภอ/แขวง: {{this.shopAddress.district === null ? '-' : this.shopAddress.district}} จังหวัด: {{this.shopAddress.province === null ? '-' : this.shopAddress.province}}
                      {{this.shopAddress.zipcode === null ? '' : this.shopAddress.zipcode}}
                    </span><br/><br/>
                    <h3><B>เกี่ยวกับร้านค้า</B></h3>
                    <v-container>
                    <v-textarea v-if="!more" id="dot" style="font-size: 13px; margin-Top:-7px; margin-left:-25px; overflow: hidden !important;" auto-grow :style="!MobileSize ? 'width: 420px;' : ''" full-width :height="showMore ? '124': '144' " hide-details readonly :value="value" no-resize rounded></v-textarea>
                    <v-textarea v-if="more" id="more" style="font-size: 13px; margin-Top:-7px; margin-left:-25px; overflow: hidden !important;" auto-grow :style="!MobileSize ? 'width: 420px;' : ''" full-width hide-details readonly :value="value" no-resize rounded></v-textarea>
                  </v-container>
                    <v-row justify="center" class="pt-2" v-if="showMore">
                      <a class="pt-1"><h3 style="color:#27AB9C" @click="seeMore()">ดูรายละเอียดเพิ่มเติม<v-icon  color="#27AB9C">mdi-chevron-down</v-icon></h3></a>
                      <!-- <a><h3 v-if="more" style="color:#27AB9C" @click="closeSeeMore()">ดูรายละเอียดเพิ่มเติม<v-icon  color="#27AB9C">mdi-chevron-down</v-icon></h3></a> -->
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6" :class="IpadSize ? 'mt-4' : ''">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-row>
                    <v-col cols="12" >
                      <v-row >
                        <v-col cols="10">
                          <h2 class="ml-4">จัดการรูปภาพ</h2>
                        </v-col>
                        <v-col cols="1" aling="end" >
                          <v-btn icon><v-icon size="24" color="#27AB9C" @click="editpictuer()">mdi-pencil</v-icon></v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" align="center" style="margin-top:-25px">
                      <v-container>
                        <v-img v-if="shop_allImage[0] === null  || shop_allImage.length === 0 || shop_allImage.length === ''"  class="rounded-lg" src="@/assets/NoImage.png" width="480" height="222" contain></v-img>
                        <v-carousel v-else
                          cycle
                          height="222"
                          hide-delimiter-background
                          show-arrows-on-hover
                          hide-delimiters
                          >
                          <v-carousel-item v-for="(slide, i) in shop_allImage" :key="i" >
                            <v-img  class="rounded-lg" :src="slide.media_path" width="480" height="222" contain></v-img>
                          </v-carousel-item>
                        </v-carousel>
                      </v-container>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card width="100%">
                  <v-card-title class="ml-4 mt-0 px-0 pt-3" style="font-size: 20px;">รายการสินค้า</v-card-title>
                  <v-card-text class="px-0 pb-3 pt-1">
                    <v-row class="ml-5" dense justify="center">
                      <v-col class="tap_left"  cols="2"><h3 style="color:#27AB9C"><B>{{ shop_countAll }}</B></h3></v-col>
                      <v-col align="center" cols="3"><h3 style="color:#27AB9C"><B>{{ shop_countBestSeller}}</B></h3></v-col>
                      <v-col align="center" cols="3"><h3 style="color:#27AB9C"><B>{{ shop_countNew }}</B></h3></v-col>
                      <v-col align="center" cols="3"><h3 style="color:#27AB9C"><B>{{ shop_countRecommnet }}</B></h3></v-col>
                      <v-col cols="3"><h3 :style="MobileSize ? 'font-size: 12px;' :'font-size: 16px;'">สินค้าทั้งหมด</h3></v-col>
                      <v-col cols="3"><h3 :style="MobileSize ? 'font-size: 12px;' :'font-size: 16px;'">สินค้าขายดี</h3></v-col>
                      <v-col cols="3"><h3 :style="MobileSize ? 'font-size: 12px;' :'font-size: 16px;'">สินค้ามาใหม่</h3></v-col>
                      <v-col cols="3"><h3 :style="MobileSize ? 'font-size: 12px;' :'font-size: 16px;'">สินค้าแนะนำ</h3></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <br/>
      <v-container v-for="(item,index) in list" :key="index">
        <v-row dense class="px-0" v-if="index < countloop">
          <v-col cols="7" class="mb-4" align="start">
            <span :style="MobileSize ? 'font-size: 20px;' : 'font-size: 24px;'"><b>{{headerlist[index]}}</b></span>
          </v-col>
          <v-col cols="5" class="mb-4 pt-1" align="end">
            <v-btn class="pr-0" text @click="SeeAllProduct(headerlist[index])" color="#27AB9C" plain style="font-weight: 600;">ดูทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-2"><v-icon color="#27AB9C">mdi-chevron-right</v-icon></v-btn></v-btn>
          </v-col>
          <v-row dense v-if="MobileSize || IpadSize" class="px-0">
            <v-col cols="6" sm="6" xs="6" v-for="(item, index) in list[index]" :key="index" class="mb-4" align="center">
              <CardProductsResponsive :itemProduct='item' style="text-align: left;"/>
            </v-col>
          </v-row>
          <v-row dense v-else-if="IpadProSize" class="px-0 pt-9">
          <v-col cols="3" sm="3" xs="3" v-for="(item, index) in list[index]" :key="index" class="mb-4" align="center">
            <CardProductsResponsive :itemProduct='item' style="text-align: left;"/>
          </v-col>
        </v-row>
        <v-row v-else justify="center" class="px-0 four-cols" style="display: grid !important;">
          <v-col v-for="(item, index) in list[index]" :key="index" align="center">
            <CardProducts :itemProduct='item' style="margin: 0 auto; text-align: left;" />
          </v-col>
        </v-row>
      </v-row>
      </v-container>
      <v-container v-if="this.listproduct > 1 && this.listproduct !== this.countloop">
        <v-row justify="center">
          <a><h3  style="color:#27AB9C" @click="addshow()">ดูรายละเอียดเพิ่มเติม<v-icon  color="#27AB9C">mdi-chevron-down</v-icon></h3></a>
        </v-row>
      </v-container>
    </v-card>

    <!-- dialog sacn -->
    <v-dialog  v-model="dialogScan" width="600" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">ลิงก์ของฉัน</font></span>
          <v-btn
            icon
            dark
            @click="dialogScan = false"
            >
            <v-icon  color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/>
        <v-card-text >
          <vue-qrcode :value="shop_url" :size="size" />
          <v-text-field readonly v-model="shop_url" class="ml-15 mr-15" placeholder="URL Link ของร้าน" max-width="383px"  outlined dense><v-icon  slot="append" color="#27AB9C">mdi-share-variant</v-icon></v-text-field>
          <v-btn dense rounded v-clipboard:copy="shop_url" v-clipboard:error="onError" v-clipboard:success="onCopy" width="165" color="#27AB9C" class=" white--text" @click="SuccessCurierAll()">คัดลอกลิงก์</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  components: {
    CardProducts: () => import('@/components/Gracz/Sales/Product/ProductCardDesktopSellerShop'),
    CardProductsResponsive: () => import('@/components/Gracz/Sales/Product/ProductCardResponsive')
    // HomeProducts: () => import('@/views/CardManageshop')
  },
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      shopId: '',
      shopName: '',
      shopPosition: '',

      // shop detail
      shopDetail: [],
      shop_image: '',
      shop_name: '',
      shopAddress: [],
      shop_province: '',
      shop_description: '',
      value: '',
      showMore: false,
      shop_url: '',
      dialogScan: false,

      // shop image
      shop_allImage: [],
      shop_countAll: 0,
      shop_countBestSeller: 0,
      shop_countNew: 0,
      shop_countRecommnet: 0,

      // product
      GetAllProduct: {
        allproduct: [],
        newArrivals: [],
        bestSeller: [],
        recommend: [],
        CategoryList: []
      },
      status: true,
      headerlist: [],
      list: [],
      countloop: 1,
      listproduct: 0,
      size: 450,
      more: null
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push(`/Order/SellerShopDetailMobile/${this.shopName}-${this.seller_shop_id}`).catch(() => {})
      } else {
        this.$router.push(`/Order/SellerShopDetail/${this.shopName}-${this.seller_shop_id}`).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    this.$EventBus.$emit('changeAppBarGracz')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        var shop = userDetailSelling
        this.seller_shop_id = shop.seller_shop_id
        this.shopName = shop.shop_name
        this.shopPosition = shop.position
      }
      this.getSellerShopDetail()
      this.getProductList()
    }
  },
  methods: {
    SeeAllProduct (header) {
      // console.log(header)
      this.$router.push(`/Order/Product?Header=${header}`).catch(() => {})
    },
    seeMore () {
      this.more = !this.more
      if (this.more) {
        this.value = this.shop_description
      } else {
        if (this.shop_description.length > 120) {
          this.value = this.shop_description.substring(0, (120 - 4)) + '...'
          this.showMore = true
        } else {
          this.value = this.shop_description
        }
      }
    },
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    async getSellerShopDetail () {
      if (this.seller_shop_id === null) { this.$router.push({ path: '/' }) }

      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczSellerShopPage', data)
      var res = await this.$store.state.ModuleGraczShop.stateGraczSellerShopPage
      if (res.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      if (res.result === 'SUCCESS') {
        this.shopDetail = res.data[0]
        localStorage.setItem('graczShopDetail', this.shopDetail)

        // shop detail
        this.shop_image = this.shopDetail.shop_profile === undefined ? '' : this.shopDetail.shop_profile[0]
        this.shop_name = this.shopDetail.shop_name
        this.shopAddress = this.shopDetail.address_detail[0]
        this.shop_province = this.shopAddress.province
        this.shop_description = this.shopDetail.shop_description
        if (this.shop_description.length > 120) {
          this.value = this.shop_description.substring(0, (120 - 4)) + '...'
          this.showMore = true
        } else {
          this.value = this.shop_description
        }
        this.shop_url = this.shopDetail.url_name

        // shop image
        this.shop_allImage = this.shopDetail.shop_image.length === 0 ? '' : this.shopDetail.shop_image
      }
      // console.log('res from API', res)
      console.log('shopDetail', this.shopDetail)
    },
    async getProductList () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        type: 'all',
        category_id: [],
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      var data1 = {
        seller_shop_id: this.seller_shop_id,
        type: 'best-seller',
        category_id: [],
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      var data2 = {
        seller_shop_id: this.seller_shop_id,
        type: 'new',
        category_id: [],
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      var data3 = {
        seller_shop_id: this.seller_shop_id,
        type: 'recommend',
        category_id: [],
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }

      await this.$store.dispatch('actionsGraczProductList', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      await this.$store.dispatch('actionsGraczProductList', data1)
      var response1 = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response1.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      await this.$store.dispatch('actionsGraczProductList', data2)
      var response2 = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response2.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      await this.$store.dispatch('actionsGraczProductList', data3)
      var response3 = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response3.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }

      this.shop_countBestSeller = 0
      this.shop_countNew = 0
      this.shop_countRecommnet = 0

      this.GetAllProduct.allproduct = []
      this.GetAllProduct.newArrivals = []
      this.GetAllProduct.bestSeller = []
      this.GetAllProduct.recommend = []
      this.listproduct = 0
      this.list = []
      this.heaederlist = []
      if (response.result === 'success') {
        // have product all
        if (response.data.products.length !== 0) {
          // product all
          if (response.data.products.length !== 0) {
            this.shop_countAll = response.data.count_product
            this.GetAllProduct.allproduct = response.data.products
            this.status = true
            this.listproduct++
            var allproduct = []
            this.GetAllProduct.allproduct.forEach((element, index) => {
              if (index <= 3) {
                allproduct.push(element)
              }
            })
            this.list.push(allproduct)
            this.headerlist.push('สินค้าทั้งหมด')
          } else {
            this.GetAllProduct.allproduct = []
            this.status = true
          }
          // product best-seller
          if (response1.data.products.length !== 0) {
            this.shop_countBestSeller = response1.data.count_product
            this.GetAllProduct.bestSeller = response1.data.products
            this.status = true
            this.listproduct++
            this.headerlist.push('สินค้าขายดี')
            var bestSeller = []
            this.GetAllProduct.bestSeller.forEach((element, index) => {
              if (index <= 3) {
                bestSeller.push(element)
              }
            })
            this.list.push(bestSeller)
            // this.list.push(this.GetAllProduct.bestSeller)
          } else {
            this.GetAllProduct.bestSeller = []
            this.status = true
          }
          // product new
          if (response2.data.products.length !== 0) {
            this.shop_countNew = response2.data.count_product
            this.GetAllProduct.newArrivals = response2.data.products
            this.status = true
            this.listproduct++
            this.headerlist.push('สินค้ามาใหม่')
            var newArrivals = []
            this.GetAllProduct.newArrivals.forEach((element, index) => {
              if (index <= 3) {
                newArrivals.push(element)
              }
            })
            this.list.push(newArrivals)
            // this.list.push(this.GetAllProduct.newArrivals)
          } else {
            this.GetAllProduct.newArrivals = []
            this.status = true
          }
          // product recomment
          if (response3.data.products.length !== 0) {
            this.shop_countRecommnet = response3.data.count_product
            this.GetAllProduct.recommend = response3.data.products
            this.status = true
            this.listproduct++
            this.headerlist.push('สินค้าแนะนำ')
            var recommend = []
            this.GetAllProduct.recommend.forEach((element, index) => {
              if (index <= 3) {
                recommend.push(element)
              }
            })
            this.list.push(recommend)
            // this.list.push(this.GetAllProduct.recommend)
          } else {
            this.GetAllProduct.recommend = []
            this.status = true
          }
        } else {
          this.GetAllProduct.allproduct = []
          this.GetAllProduct.newArrivals = []
          this.GetAllProduct.bestSeller = []
          this.GetAllProduct.recommend = []
          this.status = true
        }
      } else {
        const Toast = this.$swal.mixin({ showConfirmButton: false, timer: 1500 })
        Toast.fire({ icon: 'error', title: 'ไม่มีสินค้าในหน้าเพจ', text: 'โปรดติดต่อแอดมิน' })
      }
    },

    // scan
    dialogOpenScan () {
      this.dialogScan = true
    },
    onCopy: function (e) {
      this.$swal.fire({
        toast: true,
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        position: 'top',
        icon: 'success',
        title: 'คัดลอกลิงก์สำเร็จ!'
      })
    },
    onError: function (e) {
      alert('Failed to copy texts')
    },
    addshow () {
      if (this.countloop < this.list.length) {
        this.countloop = this.countloop + 1
        if (this.countloop === this.list.length) {
          this.icon = 'mdi-chevron-up'
        }
      } else {
        this.countloop = 1
        this.icon = 'mdi-chevron-down'
        window.scrollTo(0, 0)
      }
    },

    // p tong code
    editshop () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/EditSellerShopMobile' })
      } else {
        this.$router.push({ path: '/Order/EditSellerShop' })
      }
    },
    editpictuer () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/EditPictureShopMobile' })
      } else {
        this.$router.push({ path: '/Order/EditPictureShop' })
      }
    },
    backtoSellerMenu () {
      var shopDetail = JSON.parse(localStorage.getItem('shopDetail'))
      if (this.MobileSize) {
        this.$router.push({ path: '/sellerMobile?ShopID=' + shopDetail.id + '&ShopName=' + shopDetail.name }).catch(() => {})
      } else {
        this.$router.push({ path: '/seller?ShopID=' + shopDetail.id + '&ShopName=' + shopDetail.name })
      }
    }

    // editImage () {
    //   window.addEventListener('load', function () {
    //     document.querySelector('input[type="file"]').addEventListener('change', function () {
    //       if (this.files && this.files[0]) {
    //         var img = document.querySelector('img')
    //         img.onload = () => {
    //           URL.revokeObjectURL(img.src) // no longer needed, free memory
    //         }
    //         img.src = URL.createObjectURL(this.files[0]) // set src to blob url
    //       }
    //     })
    //   })
    // }
  }
}
</script>
<style>
.mobile14 {
  font-weight: 700; font-size: 14px;  line-height: 24px; color: #333333;
}
.one-cols {
  display: grid !important;
  grid-template-columns: repeat(1, 1fr);
}
.two-cols {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
}
.three-cols {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
}
.four-cols {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
}
/* .five-cols {
  display: grid !important;
  grid-template-columns: repeat(5, 1fr);
} */
@media (min-width:1264px) and (max-width:1412px) {
  .five-cols {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr);
  }
}
@media  screen and (min-width:1413px) {
  .five-cols {
    display: grid !important;
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
